module.exports = __webpack_public_path__ + "static/media/residential-service-contract-license.8b14ac2c.png";